const theme = {
	colors: {
		darkblue: '#101828',
		gray: '#475467',
		accentOrange: '#E44848',
		accentOrangeHover: '#d84343',
		accentYellow: '#FFC531',
		lightGray: '#F2F4F7',
		milky: '#F7F7F7',
		primaryWhite: '#fff',
		formText: 'rgba(16, 24, 40, 0.6)',
		overlayBack: 'rgba(17, 18, 19, 0.4)',	
	},
	borders: {
		mainBorder: '1px solid rgba(16, 24, 40, 0.2)',
		secondaryBorder: '1px solid rgba(16, 24, 40, 0.1)',
		accentBoldBorder: '5px solid #E44848',
		accenLighttBorder: '1px solid #E44848',
		secondaryButtonBorder: '1px solid rgba(71, 84, 103, 0.2)',
	},
	transition: '250ms cubic-bezier(0.4, 0, 0.2, 1)',
};

export default theme;
